import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChannelSubtypeLookupComponent } from './channel-subtype-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgSelectModule
    ],
    declarations: [ChannelSubtypeLookupComponent],
    exports: [ChannelSubtypeLookupComponent]
})
export class ChannelSubtypeLookupModule { }
